<template>
	<section class="container-pay-creditcard">
		<Modal
			v-if="isActiveModal"
			:modal-data="{ valorAutorizado, valorFinalPedido, pgtoId }"
			@close="isActiveModal = false"
			@confirm="confirmPaymentModal($event, pgtoId)"
		/>
		<Manual
			v-if="manualAproveModal"
			:modal-data="manualAproveData"
			:modal-loading="modalLoading"
			@close="manualAproveModal = !manualAproveModal"
			@confirm-pay-manual="createManualPayment($event)"
		/>
		<Observation
			title="Adicionar Observação"
			:active="openModalObservation"
			down-button="Adicionar"
			:red-active="false"
			:modal-loading="modalLoading"
			@close="openModalObservation = false"
			@apply="sendObservation(observacao)"
		>
			<div slot="box">
				<div class="container-observacao">
					<!--      <div class="row-observacao">
            <p class="label-item">
              Tipo:
            </p>
            <Select
              border="1px solid #cecece"
              height="35px"
              width="100%"
              hover-color="1px solid #155d276e"
              :data="tipo_obs"
              @selected="observacao.type = $event"
            />
          </div> -->
					<div class="row-observacao">
						<p class="label-item">Observação:</p>
						<textarea
							v-model="observacao.text"
							:class="obs_error ? 'error' : ''"
							class="textarea-observacao"
							name="text"
							placeholder="Digite a observação aqui...."
						/>
					</div>
				</div>
			</div>
		</Observation>
		<TabNavigation :data="situacoes" @change="filterBySituation($event)" />
		<cartao
			:data="data"
			:is-loading="isLoading"
			:condpagamentooptions="condpgtosOptions"
			backend-pagination
			:current-page="currentpage"
			:per-page="rowsperpage"
			:totalpages="totalpages"
			striped
			@add-observation="changeModalObservation($event)"
			@filterApply="filter($event)"
			@openModal="openModalPayment($event)"
			@cancel="cancelPayment($event.id)"
			@viewmore="viewMore($event)"
			@update-table="reload($event)"
			@pagechange="(currentpage = $event.pagenumber), filter($event)"
			@payment-manual="manualAprove($event)"
		/>
	</section>
</template>

<script>
import cookie from 'vue-cookie';
import cartao from '../../layout/components/table/cartao';
import * as ecAxios from '../../util/ecAxios';
import Modal from '../../layout/components/modal/cartao';
import Manual from '../../layout/components/modal/cartaomanual';
import Observation from '../../layout/components/modal/kmodal';
import global from '../../mixins/global';
import TabNavigation from '../../layout/components/Tabs/default';

export default {
	components: {
		cartao,
		Modal,
		Observation,
		Manual,
		TabNavigation,
	},
	mixins: [global],
	data() {
		return {
			currentpage: 1,
			observacao: {
				type: { id: 1, label: 'Pagamento' },
				text: '',
				pedido_id: null,
			},
			tipo_obs: [
				{ id: 1, label: 'Pagamento' },
				{ id: 2, label: 'Pedido' },
			],
			modalLoading: false,
			obs_error: false,
			isActiveModal: false,
			data: [],
			openModalObservation: false,
			manualAproveData: {},
			situacoes: [
				{
					id: 11,
					count: 0,
					active: false,
					label: 'Não Autorizado',
					icon: {
						type: 'times-circle',
						size: 'lg',
						color: '#e01e37',
					},
				},
				{
					id: 3,
					count: 0,
					active: false,
					label: 'Concluído',
					icon: {
						type: 'boxes',
						size: 'lg',
						color: '#40916c',
					},
				},
				{
					id: 1,
					count: 0,
					active: false,
					label: 'Pendente',
					icon: {
						type: 'clock',
						size: 'lg',
						color: '#ffba08',
					},
				},
				{
					id: 2,
					count: 0,
					active: false,
					label: 'Cancelado',
					icon: {
						type: 'times-circle',
						size: 'lg',
						color: '#9d0208',
					},
				},
				{
					id: 4,
					count: 0,
					active: false,
					label: 'Aguardando avaliação manual',
					icon: {
						type: 'cogs',
						size: 'lg',
						color: '#14213d',
					},
				},
				{
					id: 5,
					count: 0,
					active: false,
					label: 'Aguardando captura',
					icon: {
						type: 'pallet',
						size: 'lg',
						color: '#008000',
					},
				},
				{
					id: 6,
					count: 0,
					active: false,
					label: 'Captura em andamento',
					icon: {
						type: 'truck-loading',
						size: 'lg',
						color: '#004b23',
					},
				},
				{
					id: 7,
					count: 0,
					active: false,
					label: 'Em alerta',
					icon: {
						type: 'exclamation-triangle',
						size: 'lg',
						color: '#e01e37',
					},
				},
				{
					id: 8,
					count: 0,
					active: false,
					label: 'Aguardando cancelamento',
					icon: {
						type: 'clock',
						size: 'lg',
						color: '#ffbd00',
					},
				},
				{
					id: 9,
					count: 0,
					active: false,
					label: 'Cancelamento em andamento',
					icon: {
						type: 'clock',
						size: 'lg',
						color: '#e01e37',
					},
				},
				{
					id: 10,
					count: 0,
					active: false,
					label: 'Cancelamento aceito, aguardando',
					icon: {
						type: 'times-circle',
						size: 'lg',
						color: '#e01e37',
					},
				},
			],
			search: null,
			pgtoId: null,
			valorFinalPedido: null,
			valorAutorizado: null,
			sendAmount: null,
			dtpagamento: null,
			isLoading: true,
			condpgtosOptions: [],
			situacao: null,
			pedido_situacao: null,
			condpgto: null,
			rowsperpage: 50,
			totalpages: 1,
			manualAproveModal: false,
		};
	},
	async mounted() {
		try {
			const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PGTO_CARTAO_DENIED}`;
			const params = {
				status: ['DENIED', 'DENY'],
				orderby: 'timestamp',
			};
			const response = await ecAxios.connection().post(url, params);
			if (response.data.error === 0) {
				this.situacoes[0].count = response.data.count;
			} else {
				// eslint-disable-next-line no-throw-literal
				throw { message: response.data.message };
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error(error);
		}
		ecAxios
			.connection()
			.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_COND_PAGAMENTO}`, {
				formpgto_id: 4,
			})
			.then((response) => {
				if (!response.data.error) {
					response.data.condpgtos.forEach((element) => {
						this.condpgtosOptions.push({
							id: element.id,
							label: `ID: ${element.id} | ${element.descricao} | ID Integração: ${element.integracao_id}`,
						});
					});
				}
			})
			.catch((e) => {
				this.$buefy.notification.open({
					message: e.toString(),
					type: 'is-danger',
				});
			});
	},
	methods: {
		changeModalObservation(selected) {
			if (selected.pedido_id) {
				this.observacao.pedido_id = selected.pedido_id;
				this.openModalObservation = !this.openModalObservation;
			}
		},
		async sendObservation(observation) {
			this.modalLoading = true;
			const payload = {
				tipo: observation.type.id,
				observacao: observation.text,
				pedido_id: observation.pedido_id,
				created_by: cookie.get('logUser'),
			};
			if (payload.tipo && payload.observacao && payload.pedido_id && payload.created_by) {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.EC_OBSERVATION}`;
				const response = await ecAxios.connection().put(url, payload);
				if (response.data.error === 0) {
					this.openModalObservation = !this.openModalObservation;
					this.$buefy.notification.open({
						message: response.data.message,
						type: 'is-success',
					});
					this.observacao = {
						type: { id: 1, label: 'Pagamento' },
						text: '',
						pedido_id: null,
					};
				} else {
					this.$buefy.notification.open({
						message: response.data.message,
						type: 'is-danger',
					});
				}
			} else {
				this.obs_error = true;
			}
			this.modalLoading = false;
		},
		manualAprove(data) {
			this.manualAproveData = data;
			if (data) {
				this.manualAproveModal = !this.manualAproveModal;
			}
		},
		async createManualPayment(payment) {
			try {
				this.modalLoading = true;
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.GN_CREATE_PGTO_CRED}`;
				const response = await ecAxios.connection().post(url, payment);
				if (response.data.situacao === 1) {
					this.$buefy.notification.open({
						message: 'Pagamento realizado com sucesso',
						type: 'is-success',
					});
					this.filterBySituation(11);
					this.manualAproveModal = !this.manualAproveModal;
				} else {
					throw new Error(response.data.message || 'Ocorreu um erro ao pagar os dados');
				}
			} catch (e) {
				this.$buefy.notification.open({
					message: e.message || 'Ops! Ocorreu um erro ao salvar os dados.',
					type: 'is-danger',
				});
			}
			this.modalLoading = false;
		},
		filterBySituation(situationId) {
			if (situationId === 11) {
				const data = JSON.parse(localStorage.getItem('filter-cartao'));
				data.situationpagamento = [situationId];
				data.situacao = [situationId];
				localStorage.setItem('filter-cartao', JSON.stringify(data));
				this.getPaymentsNotListed();
			} else if (situationId) {
				const data = JSON.parse(localStorage.getItem('filter-cartao'));
				data.situationpagamento = [situationId];
				data.situacao = [situationId];
				localStorage.setItem('filter-cartao', JSON.stringify(data));
				this.filter({ limit: this.rowsperpage, offset: 0 });
			} else {
				const data = JSON.parse(localStorage.getItem('filter-cartao'));
				data.situationpagamento = [];
				data.situacao = [];
				localStorage.setItem('filter-cartao', JSON.stringify(data));
				this.filter({ limit: this.rowsperpage, offset: 0 });
			}
		},
		viewMore(params) {
			const { gateway, id } = params;
			this.$router.push({
				name: 'PagamentoCartaoDetails',
				params: { id, gateway },
			});
		},
		confirmCustomDelete(title, message, confirmText) {
			return this.$buefy.dialog.confirm({
				title,
				message,
				confirmText,
				type: 'is-danger',
				hasIcon: true,
				onConfirm: () => this.$buefy.toast.open('Processando.....'),
			});
		},
		clearVarFilters() {
			this.dtpagamento = null;
			this.pedido_situacao = null;
			this.situacao = null;
			this.condpgto = null;
			this.search = null;
			this.direction = 'desc';
			this.orderby = 'dtpagamento';
		},
		filter(pagination) {
			const data = JSON.parse(localStorage.getItem('filter-cartao'));
			this.clearVarFilters();

			if (data.dtpagamento) {
				this.dtpagamento = data.dtpagamento;
			}
			if (data.pedido_situacao) {
				this.pedido_situacao = data.pedido_situacao;
			}
			if (data.situacao) {
				this.situacao = data.situacao;
			}
			if (data.condpgto) {
				this.condpgto = data.condpgto;
			}
			if (data.searchTerm) {
				this.search = data.searchTerm;
			}
			if (data.orderby) {
				this.orderby = data.orderby;
			}
			if (data.direction) {
				this.direction = data.direction;
			}
			if (data.situacao && data.situacao[0] === 11) {
				this.getPaymentsNotListed(pagination);
			} else {
				this.getCardPayments(pagination);
			}
		},
		notification(message, type) {
			this.$buefy.notification.open({
				message: message.toString(),
				type,
			});
		},
		reload(pagination) {
			const data = JSON.parse(localStorage.getItem('filter-cartao'));
			if (data.situacao && data.situacao[0] === 11) {
				this.getPaymentsNotListed(pagination);
			} else {
				this.getCardPayments(pagination);
			}
		},
		async getPaymentsNotListed(pagination = { limit: this.rowsperpage, offset: 0 }) {
			this.isLoading = true;
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PGTO_CARTAO_DENIED}`;
				const params = {
					status: ['DENIED', 'DENY', 'NOT VERIFIED', 'NOT APPROVED'],
					orderby: 'timestamp',
					direction: 'DESC',
					limit: pagination.limit || 50,
					offset: pagination.offset || 0,
				};
				const response = await ecAxios.connection().post(url, params);
				if (response.data.error === 0) {
					this.data = response.data.pedidopgtocartao;
					this.totalpages = response.data.count;
					this.situacoes[0].count = response.data.count;
					const newData = [];

					this.data.map((item) => {
						// eslint-disable-next-line no-param-reassign
						item.formatedBrl = this.transformToBrl(item.vlrpago);
						// eslint-disable-next-line no-param-reassign
						item.cpfcnpj = this.formatCnpjCpf(item.cpfcnpj);
						newData.push(item);
						return true;
					});
					this.data = newData;
				} else {
					// eslint-disable-next-line no-throw-literal
					throw { message: response.data.message };
				}
			} catch (error) {
				// eslint-disable-next-line no-console
				console.error(error);
			}
			this.isLoading = false;
		},
		findSituation(situacaoFor, countSituacoes) {
			const findSituation =
				countSituacoes.find((situacao) => parseInt(situacao.situacao, 10) === situacaoFor.id) || 0;
			if (findSituation.qtd) {
				// eslint-disable-next-line no-param-reassign
				situacaoFor.count = findSituation.qtd;
			}
			return situacaoFor;
		},
		async getCardPayments(pagination) {
			this.isLoading = true;
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PGTO_CARTAO}`, {
					dtpagamento: {
						startDate: this.dtpagamento.startDate ? `${this.dtpagamento.startDate} 00:00:00` : '',
						endDate: this.dtpagamento.endDate ? `${this.dtpagamento.endDate} 23:59:59` : '',
					},
					pedido_situacao: this.pedido_situacao,
					situacao: this.situacao,
					condpgto: this.condpgto,
					searchTerm: this.search,
					orderby: this.orderby,
					direction: this.direction,
					limit: pagination.limit,
					offset: pagination.offset,
					formpgto_id: [4],
					count: true,
					countsituacoes: true,
				})
				.then((response) => {
					if (response.data.error === 0) {
						const { pagamentos, count, countSituacoes } = response.data;
						this.data = pagamentos;
						this.totalpages = count;

						const newData = [];

						// eslint-disable-next-line
						this.situacoes.forEach((situacaoFor) =>
							this.findSituation(situacaoFor, countSituacoes)
						);

						this.data.map((item) => {
							// eslint-disable-next-line no-param-reassign
							item.formatedBrl = this.transformToBrl(item.vlrpago);
							// eslint-disable-next-line no-param-reassign
							item.cpfcnpj = this.formatCnpjCpf(item.cpfcnpj);
							newData.push(item);
							return true;
						});
						this.data = newData;
					}
				})
				.catch();
			this.isLoading = false;
		},
		async openModalPayment(pedId) {
			this.pgtoId = null;
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC + api.env.EC_PGTO_CARTAO_SHOW}`;
				const request = await ecAxios.connection().get(`${url}${pedId}`);

				let { data } = request;
				if (data.error !== 1) {
					// eslint-disable-next-line prefer-destructuring
					data = data.pedidopgtocartao[0];
					this.pgtoId = data.id;
					this.pedidoId = data.pedido_id;
					this.valorAutorizado = data.vlrpago;
					this.gateway = data.gateway;
					this.gatewayPaymentId = data.pagamento_id;
				} else {
					// eslint-disable-next-line no-throw-literal
					throw { message: data.message };
				}
			} catch (e) {
				this.$buefy.notification.open({
					message: e.message || 'Ops! Ocorreu um erro ao presseguir com a inativação do cadastro.',
					type: 'is-success',
				});
			}
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC + api.env.EC_PEDIDO}busca-valores`;
				const request = await ecAxios.connection().post(`${url}`, {
					id: this.pedidoId,
				});

				const { data } = request;
				if (data.error !== 1) {
					const vlrPedido = parseFloat(data.valores.vlr_total).toFixed(2);

					if (vlrPedido && vlrPedido < this.valorAutorizado) {
						this.valorFinalPedido = vlrPedido;
						this.sendAmount = true;
					} else {
						this.valorFinalPedido = this.valorAutorizado;
						this.sendAmount = false;
					}

					this.isActiveModal = true;
				} else {
					// eslint-disable-next-line no-throw-literal
					throw { message: data.message };
				}
			} catch (e) {
				this.$buefy.notification.open({
					message: e.message || 'Ops! Ocorreu um erro ao presseguir com a inativação do cadastro.',
					type: 'is-success',
				});
			}
		},
		async confirmPaymentModal(modalValor, pgtoId) {
			if (!pgtoId) return;

			this.loading = true;
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PGTO_CARTAO_SHOW}${pgtoId}`;
				const payload = {
					situacao: 5,
					vlrcaptura: modalValor,
				};
				const { data } = await ecAxios.connection().put(url, payload);

				if (data.error === 0) {
					this.getCardPayments({ limit: this.rowsperpage, offset: 0 });
					this.notification(data.message, 'is-success');
					this.isActiveModal = false;
				} else {
					this.notification('Ocorreu um erro ao realizar a operação', 'is-danger');
				}
			} catch (e) {
				this.notification(e, 'is-danger');
			}

			this.loading = false;
		},
		cancelPayment(pagamentoid) {
			this.$buefy.dialog.confirm({
				title: 'Cancelar Pagamento',
				message: 'Você tem certeza que deseja cancelar esse pagamento?',
				confirmText: 'Confirmar',
				type: 'is-danger',
				hasIcon: true,
				onConfirm: () => {
					this.handleCancelPayment(pagamentoid);
					this.$buefy.toast.open('Processando.....');
				},
			});
		},
		async handleCancelPayment(paymentId) {
			if (!paymentId) return;

			this.loading = true;
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PGTO_CARTAO_SHOW}${paymentId}`;
				const payload = {
					situacao: 8,
				};
				const { data } = await ecAxios.connection().put(url, payload);

				if (data.error === 0) {
					this.getCardPayments({ limit: this.rowsperpage, offset: 0 });
					this.notification(data.message, 'is-success');
					this.isActiveModal = false;
				} else {
					this.notification('Ocorreu um erro ao realizar a operação', 'is-danger');
				}
			} catch (e) {
				this.notification(e, 'is-danger');
			}

			this.loading = false;
		},
	},
};
</script>

<style scoped>
.textarea-observacao {
	resize: none;
	all: unset;
	height: 130px !important;
	padding: 10px;
	font-size: 12px;
	border: 2px solid #dfdfe1c5;
	border-radius: 5px;
	transition: 200ms ease-in-out;
}
.textarea-observacao:focus {
	border: 2px solid #155d276e;
}
.error {
	border: 2px solid #be0e0e !important;
}

.label-item {
	margin-bottom: 7px;
	font-size: 12px;
	font-weight: bold;
}
.container-pay-creditcard {
	display: flex;
	width: 100%;
	flex-direction: column;
	min-height: 100vh;
	margin-bottom: 100px;
}
.container-observacao {
	padding: 20px;
}
.row-observacao {
	display: flex;
	flex-direction: column;
	margin-top: 10px;
}
</style>

